import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import moment from "moment";
import { ChatService } from "../../chat.service";

@Component({
  selector: "app-chat-content",
  templateUrl: "./chat-content.component.html",
  styleUrls: ["./chat-content.component.scss"],
})
export class ChatContentComponent implements OnInit {
  @ViewChild("scrollMe") scrollMe: ElementRef;
  scrolltop: number = null;
  public activeChat: Boolean;
  public chats;
  public chatUser;
  public userProfile;
  public chatMessage = "";
  public chatId: string = null;
  constructor(
    private _chatService: ChatService,
    private _coreSidebarService: CoreSidebarService,
  ) {}

  ngOnInit(): void {
    // Subscribe to Chat Change
    this._chatService.onChatOpenChange.subscribe((res) => {
      this.chatMessage = "";
      this.activeChat = res;
      setTimeout(() => {
        this.scrolltop = this.scrollMe?.nativeElement.scrollHeight | 0;
      }, 1000);
    });

    // Subscribe to Selected Chat Change
    this._chatService.onSelectedChatChange.subscribe((res) => {
      this.chats = res;
      //Prendo l'id della chat
      this.chatId = this.chats.id;
    });

    // Subscribe to Selected Chat User Change
    this._chatService.onSelectedChatUserChange.subscribe((res) => {
      this.chatUser = res;
    });

    this.userProfile = this._chatService.userProfile;
  }

  updateChat(roomId: string) {
    this.chatMessage = this.chatMessage.trim();
    if (this.chatMessage) {
      const newChat = {
        message: this.chatMessage,
        sender_hash: this.userProfile.hash,
        room_id: roomId, //Sostituire room_id con il room_id corretto
        create_date: moment(),
      };

      // If chat data is available (update chat)
      if (this.chats.messages) {
        if (newChat.message !== "") {
          if (this.chats && this.chats.messages && this.chats.messages.length > 0) {
            this.chats.messages.push(newChat);
          }
          this._chatService.updateChat(newChat, this.chatUser.hash);
          this.chatMessage = "";
          setTimeout(() => {
            this.scrolltop = this.scrollMe?.nativeElement.scrollHeight | 0;
          }, 0);
        }
      }
      // Else create new chat
      else {
        this._chatService.createNewChat(this.chatUser, newChat);
        this.chatMessage = "";
      }
    }
  }

  toggleSidebar(name) {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}
